export default {
	methods: {
		$currentRouteMatches(object) {
			return this.$router.match(object)?.path === this.$router.currentRoute.path;
		},
	},
};
